import { Group } from 'src/AngularJS/Models/group.model';
import { ApplicationDTO} from '../forms/forms.model';

export interface RecordingSettings {
    StartDate: Date;
    EndDate: Date;
    LengthMin: string;
    LengthMax: string;
    ContactType: number;
    ContactStatus: number;
    ContactId: string;
    ContactSource: string;
    OtherId: string;
    SelectedDisposition: string;
    SelectedFlag: string;
    ResultsLimit: number;
    IsRandomized: boolean;
    RedialRadio: number;
    OccurMin: string;
}

export interface ManualRecordingSettings {
    EmpGroupId: number;
    RecLevel: number;
    RecGroupId: number;
    ContactDate: Date;
    ContactId: string;
    Phone: string;
    Disposition: string;
    OtherId: string;
    Notes: string;
}

export interface RecordingFlagDTO {
    CompanyID: number;
    RecordingFlagID: number;
    RecordingFlagName: string;
    RecordingFlagDesc: string;
    Active: boolean;
    Type: number;
}

export interface DispositionDTO {
    GroupID: number;
    GroupName: string;
    StartDate: Date;
    DispositionName: string;
    DispositionCategory: string;
    DispositionClass: string;
    DispositionClass2: string;
    DispositionClass3: string;
    DispositionCount: number;
    TotalDispositionCount: number;
    DispositionPercentage: number;
    HandleTime: string;
}

export interface RecordingWTO {
    RecordingID: number;
    CompanyID: number;
    RecordingName: string;
    RecordingDate: Date;
    ContactID: number;
    OtherID: string;
    ContactSource: string;
    Disposition: string;
    RecordingType: number;
    RecordingPath: string;
    Transcript: string;
    Length: number;
    RecordingSize: number;
    EmpGroup1ID: number;
    EmpGroup2ID: number;
    EmpGroup3ID: number;
    EmpGroup4ID: number;
    EmpGroup5ID: number;
    RecGroup1ID: number;
    RecGroup2ID: number;
    RecGroup3ID: number;
    RecGroup4ID: number;
    RecGroup5ID: number;
    Monitorable: boolean;
    Notes: string;
    RecordingDate_UTC: Date;
    EmpGroup1Name: string;
    EmpGroup2Name: string;
    EmpGroup3Name: string;
    EmpGroup4Name: string;
    EmpGroup5Name: string;
    RecGroup1Name: string;
    RecGroup2Name: string;
    RecGroup3Name: string;
    RecGroup4Name: string;

    MonitorData: MonitorData[];
    AudioUrl: string;
    Flags: RecordingFlagDTO[];
    ExtraDataPulled: boolean;
}

export interface MonitoredRecordingDTO {
    MonitoredRecordingID: number;
    RecordingID: number;
    ApplicationID: number;
    CompanyID: number;
    MonitorID: number;
    MonitorType: number;
    DateMonitored: Date;
    TimeMonitoredStart: Date;
    RecordingDate: Date;
    ContactID: number;
    ContactIDAsString: string;
    Disposition: string;
    ContactSource: string;
    RecordingType: number;
    EmpGroup1ID: number;
    EmpGroup2ID: number;
    EmpGroup3ID: number;
    EmpGroup4ID: number;
    EmpGroup5ID: number;
    RecGroup1ID: number;
    RecGroup2ID: number;
    RecGroup3ID: number;
    RecGroup4ID: number;
    RecGroup5ID: number;
    EditorID: number;
    RecordingLength: number;
    Score: number;
    Alerts: number;
    DisputeStatus: number;
    DisputeDate: Date;
    DisputeBy: string;
    DisputeNotes: string;
    ResolvedDate: Date;
    ResolvedBy: number;
    ResolutionNotes: string;
    DisplayMonitorName: string;
    DateMonitored_UTC: Date;
    RecordingDate_UTC: Date;
    DisputeDate_UTC: Date;
    ResolvedDate_UTC: Date;
}

export interface GroupLists {
    Emp1Label: string;
    Emp1Groups: Group[];
    RecLevels: any[]; // Possibly change this type
    RecGroupsDictionary: { [key: number]: Group[] };
}

export interface MonitorData {
    ApplicationDto: ApplicationDTO;
    MonitoredRecordingDto: MonitoredRecordingDTO;
    CalibrationRecordingDto: MonitoredRecordingDTO;
}

export interface SecurityData {
    MonitorRecordingAccess: boolean;
    CalibrationRecordingAccess: boolean;
    MonitorableStatusAccess: boolean;
}

export enum View {
    Landing = 0,
    ResultList = 1,
    Details = 2,
}
